import { $, addAction, INIT } from '@situation/setdesign.util';

const setPlayingState = ($player, $button, isPlaying) => {
    $player.toggleClass('audioplayer--playing', isPlaying);
    $button.attr('aria-label', isPlaying ? 'Pause audio' : 'Play audio');
    $button.attr('aria-pressed', isPlaying);
};

addAction(INIT, () => {
    $('.audioplayer').each((_, el) => {
        const $player = $(el);
        const $audio = $player.find('.audioplayer__audio');
        const $button = $player.find('.audioplayer__button');
        const audioEl = $audio[0];
        if (!audioEl) {
            return;
        }

        $button.on('click', () => {
            if (audioEl.paused) {
                audioEl.play();
                setPlayingState($player, $button, true);
            } else {
                audioEl.pause();
                setPlayingState($player, $button, false);
            }
        });

        $audio.on('ended pause', () => {
            setPlayingState($player, $button, false);
        });
    });
});
